export default class View {
  _data;

  render(data) {
    this._data = data;
  }
}
